import dayjs from 'dayjs'
import { ReactNode } from 'react'
import { FaCalendar, FaExclamationCircle } from 'react-icons/fa'

export enum Attention {
  Low,
  Moderate,
  High
}

interface WorkflowStatusProps {
  attention: Attention
  date: Date
}

const attentionClasses = {
  [Attention.Low]: 'bg-white text-mostlyGreen border border-mostlyGreen',
  [Attention.Moderate]: 'bg-warningLight text-warning',
  [Attention.High]: 'bg-pink text-error'
}

const attentionIcons: Record<Attention, ReactNode> = {
  [Attention.Low]: <FaCalendar />,
  [Attention.Moderate]: <FaExclamationCircle />,
  [Attention.High]: <FaExclamationCircle className='rotate-180' />
}

export const WorkflowStatus = ({ attention, date }: WorkflowStatusProps) => {
  const title = attention === Attention.High ? 'Overdue' : 'Due'
  const className = attentionClasses[attention]
  const icon = attentionIcons[attention]

  return (
    <div
      className={`font-bold ${className} px-2 py-1 inline-flex items-center`}
    >
      <span className='pr-2'>{icon}</span>
      {title} {dayjs(date).format('D MMM YYYY')}
    </div>
  )
}
